import React from 'react';

import {Section} from 'common/components/items-menu/types';
import {SelectReact} from 'common/components/select';
import {SelectTheme} from 'common/components/select/constants';

export function OverflowControls(props: {items: Section[]; onMenuChange?: (isOpen?: boolean) => void}) {
  return (
    <SelectReact
      neverShowCaret
      iconOnly
      experimentalPositioning
      theme={SelectTheme.Tertiary}
      sections={props.items}
      menuWidth={-1} // adjusts the menu width to hug content
      menuHeight={-1}
      icon={{leftIcon: `ellipsis`}}
      onMenuChange={(ev) => props.onMenuChange?.(ev.detail.isOpen)}
    />
  );
}
